import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarState {
  // State
  sidebarCollapsed: boolean;
  sidebarGroupsCollapsed: boolean;
  
  // Actions
  toggleSidebar: () => void;
  toggleSidebarGroups: () => void;
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      // Initial state
      sidebarCollapsed: false,
      sidebarGroupsCollapsed: false,
      
      // Toggle sidebar collapsed/expanded
      toggleSidebar: () => set((state) => {
        const newValue = !state.sidebarCollapsed;
        console.log('[SidebarStore] toggleSidebar:', newValue);
        return { sidebarCollapsed: newValue };
      }),
      
      // Toggle menu groups collapsed/expanded
      toggleSidebarGroups: () => set((state) => {
        const newValue = !state.sidebarGroupsCollapsed;
        console.log('[SidebarStore] toggleSidebarGroups:', newValue);
        return { sidebarGroupsCollapsed: newValue };
      }),
    }),
    {
      name: 'sidebar-storage', // localStorage key
    }
  )
);
